// MenuItems.js

export const MenuItems = [
  {
    title: "Home",
    url: "/",
    cName: "nav-links",
    icon: "fa-solid fa-house",
  },

  {
    title: "Get Directions",
    url: "https://www.google.com/maps/place/ARYAN+INFOTECH/@23.0339476,72.5588293,17z/data=!3m1!4b1!4m6!3m5!1s0x395e85b797314f3b:0xa0732f080124143b!8m2!3d23.0339427!4d72.5614042!16s%2Fg%2F11q98cq893?entry=ttu", // Replace with your actual coordinates
    cName: "nav-links",
    icon: "fa-solid fa-location-dot",
  },
];
